<script>
// import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import { required, minLength, maxLength, helpers } from "vuelidate/lib/validators";
import DropzonePopup from "../../../components/widgets/dropzone-popup";
import { error_message, success_message } from "../../../state/helpers";
const mobileNumberValidator = helpers.regex(
  "alphaNumAndDot",
  /^(\+\d{1,3}[- ]?)?\d{10}$/
);
export default {
  page: {
    title: "User-View",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: { DropzonePopup },
  computed: mapGetters("user", ["userData"]),
  data() {
    return {
      title: "User",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "User",
          active: true,
        },
      ],
      user: {
        first_name: "",
        last_name: "",
        email: "",
        id: "",
        status: "",
        image: "",
        mobile_number: "",
      },
      profile_image: "",
      profile_image_path: "",
      profile_image_delete_url: process.env.VUE_APP_APIURL + "delete-user-image",
    };
  },
  validations: {
    user: {
      first_name: {
        required,
      },
      last_name: {
        required,
      },
      email: {
        required,
      },
      mobile_number: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(13),
        mobileNumberValidator,
      },
      // image: {
      //   required: requiredIf(function () {
      //     return !(!!this.profile_image || !!this.user.image);
      //   }),
      // },
    },
  },
  mounted() {
    this.getUserDetail();
  },
  methods: {
    ...mapActions("user", ["getUser", "updateUser"]),

    onUserImagedeleted() {
      this.profile_image = "";
    },

    getUserDetail() {
      let id = this.$route.params.id;
      this.getUser({ id: id }).then((response) => {
        const {
          id,
          first_name,
          last_name,
          email,
          status,
          mobile_number,
        } = response.data.result;
        this.profile_image_path = response.data.result.profile_image_path;
        this.profile_image = response.data.result.profile_image;
        this.id = response.data.result.id;
        this.user = { id, first_name, last_name, email, mobile_number, status };
      });
    },

    profileInIt() {
      this.$v.$touch();
      if (this.$v.user.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("id", this.user.id);
        fd.append("first_name", this.user.first_name);
        fd.append("last_name", this.user.last_name);
        fd.append("email", this.user.email);
        fd.append("status", this.user.status);
        fd.append("mobile_number", this.user.mobile_number);
        if (this.user.image) {
          fd.append("image", this.user.image);
        }
        console.log(fd);
        this.updateUser(fd).then((response) => {
          console.log("response", response);
          if (response.data.code === 200) {
            success_message(response.data.msg);
            this.$router.push({ name: "user-list" });
          } else {
            error_message(response.data.mmsg);
          }
        });
      }
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <b-form action="#" @submit.prevent="profileInIt">
        <!-- profile Info Start -->
        <div class="card details-profile-main">
          <div class="card-body">
            <h4 class="card-title"></h4>
            <p class="card-title-desc"></p>

            <div class="row">
              <div class="form-group">
                <input
                  id="id"
                  name="id"
                  type="hidden"
                  @id="user.id"
                  v-model="user.id"
                  class="form-control"
                />
              </div>
              <div class="col-sm-6">
                <b-form-group
                  id="input-group-1"
                  label="First Name"
                  label-for="first_name"
                  label-class="required"
                >
                  <b-form-input
                    id="first_name"
                    name="first_name"
                    v-model="$v.user.first_name.$model"
                    type="text"
                    placeholder="First Name"
                    :class="{ 'is-invalid': $v.user.first_name.$error }"
                  ></b-form-input>
                  <div v-if="$v.user.first_name.$error" class="invalid-feedback">
                    <span v-if="!$v.user.first_name.required"
                      >First name is required.</span
                    >
                  </div>
                </b-form-group>
              </div>

              <div class="col-sm-6">
                <b-form-group
                  id="input-group-1"
                  label="Last Name"
                  label-for="last_name"
                  label-class="required"
                >
                  <b-form-input
                    id="last_name"
                    name="last_name"
                    v-model="$v.user.last_name.$model"
                    type="text"
                    placeholder="Last Name"
                    :class="{ 'is-invalid': $v.user.last_name.$error }"
                  ></b-form-input>
                  <div v-if="$v.user.last_name.$error" class="invalid-feedback">
                    <span v-if="!$v.user.last_name.required">Last name is required.</span>
                  </div>
                </b-form-group>
              </div>

              <div class="col-sm-6">
                <b-form-group
                  id="input-group-1"
                  label="Email"
                  label-for="email"
                  label-class="required"
                >
                  <b-form-input
                    id="email"
                    name="email"
                    v-model="$v.user.email.$model"
                    type="text"
                    placeholder="Email"
                    :class="{ 'is-invalid': $v.user.email.$error }"
                  ></b-form-input>
                  <div v-if="$v.user.email.$error" class="invalid-feedback">
                    <span v-if="!$v.user.email.required">Email is required.</span>
                  </div>
                </b-form-group>
              </div>

              <div class="col-sm-6">
                <b-form-group
                  id="input-group-1"
                  label="Mobile Number [Use (+91)]"
                  label-for="mobile_number"
                  label-class="required"
                >
                  <b-form-input
                    id="mobile_number"
                    name="mobile_number"
                    v-model="$v.user.mobile_number.$model"
                    type="text"
                    placeholder="Mobile Number"
                    :class="{ 'is-invalid': $v.user.mobile_number.$error }"
                  ></b-form-input>
                  <div v-if="$v.user.mobile_number.$error" class="invalid-feedback">
                    <span v-if="!$v.user.mobile_number.required"
                      >Mobile Number is required.</span
                    >
                    <span v-if="!$v.user.mobile_number.minLength"
                      >Please enter minimum 10 digit</span
                    >
                    <span v-if="!$v.user.mobile_number.maxLength"
                      >Please enter maximum 12 digit</span
                    >
                    <span v-if="!$v.user.mobile_number.mobileNumberValidator">
                      Format is not correct or special character not allowed</span
                    >
                  </div>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 vendor-status">
                <label>Status</label>
                <b-form-checkbox
                  switch
                  size="lg"
                  v-model="user.status"
                  class="ml-1"
                  value="1"
                  unchecked-value="0"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
        </div>
        <!-- user Info End -->

        <!-- user Image Start -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title required">User Image</h4>
            <p class="card-title-desc"></p>

            <div class="row">
              <div class="col-sm-3">
                <dropzone-popup
                  type="file"
                  v-model="user.image"
                  id="profile_image"
                  acceptedFiles=".jpeg,.jpg,.png"
                  :editable-images="profile_image"
                  :media-path="profile_image_path + '/original'"
                  :delete-path="profile_image_delete_url"
                  :custom-params="{ id: $route.params.id }"
                  @image-deleted="this.onUserImagedeleted"
                />
                <!-- <div v-if="$v.user.image.$error" class="invalid-feedback cuisine-img">
                  <span v-if="!$v.user.image.required">Image is required.</span>
                </div> -->
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <button class="btn btn-primary mr-1 mt-3">Update</button>
                <b-button
                  @click="$router.go(-1)"
                  type="button"
                  variant="secondary"
                  class="mt-3"
                  >Cancel</b-button
                >
              </div>
            </div>
          </div>
        </div>
        <!-- user Image End -->
      </b-form>
    </div>
  </div>
</template>
